module.exports = __webpack_public_path__ + "img/logo2-en.eb068dde.png";